import {
  FetchOptions,
  HttpMethod,
  PathsWithMethod,
  createClient,
  createFetchClient,
} from "@punto/api-client";

import { config } from "@/lib/config";

import { type paths } from "./schema";

const wrappedFetch: typeof fetch = (...args) => {
  return fetch(...args);
};

const fetchClient = createFetchClient<paths>({
  baseUrl: config.API_URL,
  fetch: wrappedFetch,
});

const $api = createClient(fetchClient);

type Paths<M extends HttpMethod> = PathsWithMethod<paths, M>;
type Params<M extends HttpMethod, P extends Paths<M>> = M extends keyof paths[P]
  ? FetchOptions<paths[P][M]>
  : never;

export { fetchClient, $api, type Paths, type Params };
